import { useState } from "react";
import { LegalDocument, PRIVACY_VERSION, TERMS_VERSION } from "../legal/LegalDocument";

// eslint-disable-next-line no-unused-vars
const C = {
  bg: "#080d14",
  bgCard: "#0d1520",
  bgCardHover: "#111d2e",
  border: "#1a2a3a",
  borderHover: "#2a4060",
  cyan: "#00d4ff",
  copper: "#b87333",
  copperLight: "#d4915a",
  red: "#f85149",
  green: "#3fb950",
  amber: "#febc2e",
  textPrimary: "#e6edf3",
  textSecondary: "#8b949e",
  textMuted: "#4a5568",
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&family=Inter:wght@300;400;500&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  body{background:#080d14;color:#e6edf3;font-family:'Inter',sans-serif;overflow-x:hidden;}
  .landing{background:#080d14;min-height:100vh;position:relative;}
  .landing::before{content:'';position:fixed;inset:0;background-image:linear-gradient(rgba(0,212,255,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(0,212,255,0.025) 1px,transparent 1px);background-size:48px 48px;pointer-events:none;z-index:0;}
  .nav{position:fixed;top:0;left:0;right:0;z-index:100;display:flex;align-items:center;justify-content:space-between;padding:16px 48px;background:rgba(8,13,20,0.9);backdrop-filter:blur(12px);border-bottom:1px solid rgba(0,212,255,0.07);}
  .nav-logo{font-family:'Bricolage Grotesque',sans-serif;font-size:17px;font-weight:800;color:#e6edf3;letter-spacing:1.5px;display:flex;align-items:center;gap:10px;}
  .nav-dot{width:7px;height:7px;border-radius:50%;background:#00d4ff;box-shadow:0 0 8px #00d4ff;animation:pulse 2s infinite;}
  @keyframes pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:0.5;transform:scale(0.75);}}
  .nav-links{display:flex;gap:32px;}
  .nav-links a{font-size:13px;color:#8b949e;text-decoration:none;transition:color 0.2s;}
  .nav-links a:hover{color:#e6edf3;}
  .nav-cta{background:transparent;border:1px solid #00d4ff;color:#00d4ff;font-size:13px;font-family:'Inter',sans-serif;font-weight:500;padding:8px 20px;border-radius:4px;cursor:pointer;transition:all 0.2s;}
  .nav-cta:hover{background:rgba(0,212,255,0.08);}
  .hero{position:relative;z-index:1;padding:160px 48px 80px;max-width:1100px;margin:0 auto;}
  .eyebrow{display:inline-flex;align-items:center;gap:8px;font-family:'JetBrains Mono',monospace;font-size:11px;color:#b87333;letter-spacing:2px;text-transform:uppercase;margin-bottom:24px;border:1px solid rgba(184,115,51,0.3);padding:6px 14px;border-radius:2px;background:rgba(184,115,51,0.05);}
  .eyebrow::before{content:'';width:5px;height:5px;background:#b87333;border-radius:50%;}
  .hero h1{font-family:'Bricolage Grotesque',sans-serif;font-size:68px;font-weight:800;line-height:1.06;letter-spacing:-2.5px;color:#e6edf3;margin-bottom:24px;max-width:780px;}
  .hero h1 em{font-style:normal;color:#00d4ff;text-shadow:0 0 40px rgba(0,212,255,0.25);}
  .hero-sub{font-size:17px;color:#8b949e;line-height:1.7;max-width:520px;margin-bottom:44px;font-weight:300;}
  .hero-btns{display:flex;gap:14px;margin-bottom:32px;}
  .btn-p{background:#00d4ff;color:#080d14;font-size:14px;font-family:'Inter',sans-serif;font-weight:600;padding:13px 30px;border-radius:4px;border:none;cursor:pointer;transition:all 0.2s;letter-spacing:0.2px;}
  .btn-p:hover{box-shadow:0 0 28px rgba(0,212,255,0.35);transform:translateY(-1px);}
  .btn-g{background:transparent;color:#8b949e;font-size:14px;font-family:'Inter',sans-serif;padding:13px 30px;border-radius:4px;border:1px solid #1a2a3a;cursor:pointer;transition:all 0.2s;}
  .btn-g:hover{border-color:#2a4060;color:#e6edf3;}
  .hero-meta{font-size:11px;color:#4a5568;font-family:'JetBrains Mono',monospace;letter-spacing:0.5px;}
  .hero-meta span{color:#8b949e;margin:0 8px;}
  .stats{position:relative;z-index:1;display:flex;max-width:1100px;margin:0 auto;border:1px solid #1a2a3a;border-radius:4px;overflow:hidden;background:#0d1520;}
  .stat{flex:1;padding:26px 20px;text-align:center;border-right:1px solid #1a2a3a;}
  .stat:last-child{border-right:none;}
  .stat-n{font-family:'Bricolage Grotesque',sans-serif;font-size:30px;font-weight:700;letter-spacing:-1px;margin-bottom:4px;}
  .stat-l{font-size:11px;color:#4a5568;font-family:'JetBrains Mono',monospace;letter-spacing:0.5px;text-transform:uppercase;}
  .wrap{position:relative;z-index:1;max-width:1100px;margin:0 auto;padding:80px 48px;}
  .sec-label{font-family:'JetBrains Mono',monospace;font-size:10px;color:#b87333;letter-spacing:2px;text-transform:uppercase;margin-bottom:12px;}
  .sec-h2{font-family:'Bricolage Grotesque',sans-serif;font-size:38px;font-weight:700;letter-spacing:-1px;color:#e6edf3;margin-bottom:12px;line-height:1.15;}
  .sec-sub{font-size:15px;color:#8b949e;line-height:1.6;margin-bottom:40px;max-width:480px;}
  .dash-frame{border:1px solid rgba(0,212,255,0.12);border-radius:8px;overflow:hidden;background:#060c14;box-shadow:0 0 60px rgba(0,212,255,0.04);}
  .dash-bar{background:#040810;padding:10px 16px;display:flex;align-items:center;gap:7px;border-bottom:1px solid rgba(0,212,255,0.07);}
  .d{width:10px;height:10px;border-radius:50%;}
  .dr{background:#ff5f57;}.dy{background:#febc2e;}.dg{background:#28c840;}
  .dash-url{font-family:'JetBrains Mono',monospace;font-size:11px;color:#4a5568;margin-left:10px;}
  .dash-grid{padding:18px;display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:10px;}
  .dk{background:#040810;border:1px solid rgba(0,212,255,0.07);border-radius:6px;padding:13px;}
  .dk-l{font-family:'JetBrains Mono',monospace;font-size:9px;color:#4a5568;letter-spacing:1px;text-transform:uppercase;margin-bottom:5px;}
  .dk-v{font-family:'JetBrains Mono',monospace;font-size:19px;font-weight:500;}
  .dk-s{font-size:11px;margin-top:3px;color:#4a5568;}
  .dw{grid-column:span 2;}.df{grid-column:span 4;}
  .da{background:#040810;border:1px solid rgba(0,212,255,0.07);border-left:3px solid #f85149;border-radius:6px;padding:12px 14px;grid-column:span 2;}
  .da-t{font-size:12px;font-weight:500;color:#e6edf3;margin-bottom:3px;}
  .da-s{font-size:11px;color:#4a5568;}
  .da-c{font-family:'JetBrains Mono',monospace;font-size:13px;font-weight:500;color:#f85149;float:right;margin-top:-17px;}
  .feat-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:1px;background:#1a2a3a;border:1px solid #1a2a3a;border-radius:8px;overflow:hidden;}
  .fc{background:#0d1520;padding:28px;transition:background 0.2s;}
  .fc:hover{background:#111d2e;}
  .fc-icon{width:38px;height:38px;border-radius:7px;border:1px solid rgba(0,212,255,0.18);display:flex;align-items:center;justify-content:center;margin-bottom:14px;font-size:17px;background:rgba(0,212,255,0.04);}
  .fc-tag{font-family:'JetBrains Mono',monospace;font-size:9px;color:#b87333;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:7px;}
  .fc-title{font-family:'Bricolage Grotesque',sans-serif;font-size:16px;font-weight:600;color:#e6edf3;margin-bottom:8px;letter-spacing:-0.2px;}
  .fc-desc{font-size:13px;color:#8b949e;line-height:1.6;}
  .det-row{display:flex;align-items:center;justify-content:space-between;padding:15px 20px;border:1px solid #1a2a3a;border-top:none;transition:background 0.15s;}
  .det-row:first-child{border-top:1px solid #1a2a3a;border-radius:6px 6px 0 0;}
  .det-row:last-child{border-radius:0 0 6px 6px;}
  .det-row:hover{background:#0d1520;}
  .det-bar{width:3px;height:30px;border-radius:2px;flex-shrink:0;}
  .det-name{font-size:13px;font-weight:500;color:#e6edf3;}
  .det-suite{font-family:'JetBrains Mono',monospace;font-size:10px;color:#4a5568;letter-spacing:0.3px;}
  .det-cost{font-family:'JetBrains Mono',monospace;font-size:13px;font-weight:500;color:#f85149;}
  .p-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;max-width:680px;}
  .p-card{background:#0d1520;border:1px solid #1a2a3a;border-radius:8px;padding:28px;position:relative;}
  .p-card.p-feat{border-color:#00d4ff;box-shadow:0 0 32px rgba(0,212,255,0.06);}
  .p-badge{position:absolute;top:-11px;left:50%;transform:translateX(-50%);background:#00d4ff;color:#080d14;font-size:10px;font-weight:700;font-family:'JetBrains Mono',monospace;letter-spacing:1px;padding:3px 12px;border-radius:2px;text-transform:uppercase;}
  .p-name{font-family:'JetBrains Mono',monospace;font-size:10px;color:#4a5568;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:10px;}
  .p-price{font-family:'Bricolage Grotesque',sans-serif;font-size:44px;font-weight:700;color:#e6edf3;letter-spacing:-2px;margin-bottom:3px;}
  .p-price span{font-size:16px;font-weight:400;color:#8b949e;letter-spacing:0;}
  .p-save{font-size:12px;color:#3fb950;margin-bottom:20px;font-family:'JetBrains Mono',monospace;}
  .p-div{border:none;border-top:1px solid #1a2a3a;margin:18px 0;}
  .p-feats{list-style:none;display:flex;flex-direction:column;gap:9px;margin-bottom:24px;}
  .p-feats li{display:flex;align-items:center;gap:9px;font-size:13px;color:#8b949e;}
  .p-feats li::before{content:'→';color:#00d4ff;font-family:'JetBrains Mono',monospace;font-size:11px;flex-shrink:0;}
  .p-btn{width:100%;padding:11px;border-radius:4px;font-size:13px;font-family:'Inter',sans-serif;font-weight:500;cursor:pointer;transition:all 0.2s;}
  .pb-p{background:#00d4ff;color:#080d14;border:none;}
  .pb-p:hover{box-shadow:0 0 20px rgba(0,212,255,0.3);}
  .pb-g{background:transparent;color:#8b949e;border:1px solid #1a2a3a;}
  .pb-g:hover{border-color:#2a4060;color:#e6edf3;}
  .p-note{font-size:11px;color:#4a5568;font-family:'JetBrains Mono',monospace;letter-spacing:0.3px;margin-top:16px;}
  .demo-grid{display:grid;grid-template-columns:1fr 1fr;gap:72px;}
  .step-item{display:flex;gap:18px;padding:22px 0;border-bottom:1px solid #1a2a3a;}
  .step-item:last-child{border-bottom:none;}
  .step-n{font-family:'JetBrains Mono',monospace;font-size:11px;color:#00d4ff;letter-spacing:1px;width:24px;flex-shrink:0;margin-top:2px;}
  .step-title{font-family:'Bricolage Grotesque',sans-serif;font-size:15px;font-weight:600;color:#e6edf3;margin-bottom:5px;letter-spacing:-0.2px;}
  .step-desc{font-size:13px;color:#8b949e;line-height:1.6;}
  .cta-block{background:linear-gradient(135deg,rgba(0,212,255,0.035) 0%,rgba(184,115,51,0.035) 100%);border:1px solid rgba(0,212,255,0.12);border-radius:8px;padding:72px 80px;text-align:center;position:relative;overflow:hidden;}
  .cta-block::before{content:'';position:absolute;top:-1px;left:50%;transform:translateX(-50%);width:180px;height:2px;background:linear-gradient(90deg,transparent,#00d4ff,transparent);}
  .cta-h2{font-family:'Bricolage Grotesque',sans-serif;font-size:44px;font-weight:700;color:#e6edf3;letter-spacing:-1.5px;margin-bottom:14px;}
  .cta-sub{font-size:16px;color:#8b949e;margin-bottom:36px;font-weight:300;}
  .cta-btns{display:flex;gap:14px;justify-content:center;margin-bottom:18px;}
  .cta-note{font-family:'JetBrains Mono',monospace;font-size:11px;color:#4a5568;letter-spacing:0.5px;}
  .footer{position:relative;z-index:1;border-top:1px solid #1a2a3a;padding:28px 48px;display:flex;align-items:center;justify-content:space-between;}
  .footer-logo{font-family:'Bricolage Grotesque',sans-serif;font-size:13px;font-weight:700;color:#4a5568;letter-spacing:1.5px;}
  .footer-links{display:flex;gap:20px;}
  .footer-links a{font-size:11px;color:#4a5568;text-decoration:none;font-family:'JetBrains Mono',monospace;transition:color 0.2s;}
  .footer-links a:hover{color:#8b949e;}
  .footer-copy{font-size:11px;color:#4a5568;font-family:'JetBrains Mono',monospace;}
  .divider{border:none;border-top:1px solid #1a2a3a;max-width:1100px;margin:0 auto;}
  .tid-layout{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
  .tid-card{background:linear-gradient(135deg,#0f1420 0%,#141926 100%);border:1px solid rgba(0,212,255,0.18);border-left:3px solid #febc2e;border-radius:10px;padding:22px 24px;}
  .tid-meta{font-family:'JetBrains Mono',monospace;font-size:10px;color:#4a5568;text-transform:uppercase;letter-spacing:0.1em;font-weight:700;margin-bottom:10px;}
  .tid-type{display:flex;align-items:center;gap:10px;margin-bottom:10px;}
  .tid-icon{font-size:22px;line-height:1;}
  .tid-name{font-family:'Bricolage Grotesque',sans-serif;font-size:20px;font-weight:800;color:#febc2e;letter-spacing:-0.3px;}
  .tid-desc{font-size:12px;color:#c9d1d9;line-height:1.65;margin-bottom:10px;}
  .tid-edge{font-family:'JetBrains Mono',monospace;font-size:11px;color:#8b949e;line-height:1.6;margin-bottom:14px;}
  .tid-badge{display:inline-flex;align-items:center;gap:6px;font-family:'JetBrains Mono',monospace;font-size:10px;color:#3fb950;border:1px solid rgba(63,185,80,0.25);background:rgba(63,185,80,0.06);border-radius:4px;padding:4px 10px;}
  .tid-score{background:#0b0d19;border:1px solid #1a2a3a;border-radius:10px;padding:22px 24px;}
  .tid-score-label{font-family:'JetBrains Mono',monospace;font-size:9px;color:#4a5568;letter-spacing:0.1em;text-transform:uppercase;margin-bottom:4px;}
  .tid-score-num{font-family:'JetBrains Mono',monospace;font-size:52px;font-weight:900;color:#3fb950;line-height:1;margin-bottom:3px;}
  .tid-score-tier{font-family:'JetBrains Mono',monospace;font-size:10px;color:#3fb950;letter-spacing:2px;text-transform:uppercase;margin-bottom:18px;}
  .tid-bar-row{margin-bottom:11px;}
  .tid-bar-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;}
  .tid-bar-name{font-family:'JetBrains Mono',monospace;font-size:10px;color:#8b949e;letter-spacing:0.3px;}
  .tid-bar-score{font-family:'JetBrains Mono',monospace;font-size:10px;font-weight:700;}
  .tid-bar-track{height:3px;background:#1a2a3a;border-radius:2px;overflow:hidden;}
  .tid-bar-fill{height:100%;border-radius:2px;}
  .tid-tip{margin-top:14px;padding-top:14px;border-top:1px solid #1a2a3a;font-size:11px;color:#4a5568;line-height:1.6;display:flex;gap:7px;}
  .tid-types{grid-column:span 2;display:grid;grid-template-columns:repeat(6,1fr);gap:8px;margin-top:4px;}
  .tid-pill{background:#060c14;border:1px solid #1a2a3a;border-radius:6px;padding:10px 10px 10px 12px;display:flex;flex-direction:column;gap:3px;}
  .tid-pill.tid-active{border-color:rgba(254,188,46,0.35);background:rgba(254,188,46,0.04);}
  .tid-pill-icon{font-size:15px;margin-bottom:3px;}
  .tid-pill-name{font-family:'Bricolage Grotesque',sans-serif;font-size:11px;font-weight:700;color:#4a5568;line-height:1.2;}
  .tid-pill-name.tid-active{color:#febc2e;}
  .tid-pill-tag{font-family:'JetBrains Mono',monospace;font-size:8px;color:#2a3a4a;letter-spacing:0.3px;margin-top:1px;}
  .comp-section{background:linear-gradient(135deg,rgba(0,212,255,0.04) 0%,rgba(0,212,255,0.01) 100%);border:1px solid rgba(0,212,255,0.18);border-radius:10px;padding:48px;position:relative;max-width:1100px;margin:0 auto;}
  .comp-section::before{content:'NEW';position:absolute;top:-10px;left:32px;background:#00d4ff;color:#080d14;font-size:9px;font-weight:800;font-family:'JetBrains Mono',monospace;letter-spacing:1.5px;padding:3px 10px;border-radius:2px;}
  .comp-grid{display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:center;}
  .comp-checklist{display:flex;flex-direction:column;gap:9px;margin-bottom:24px;}
  .comp-check{display:flex;align-items:center;gap:10px;font-size:13px;color:#8b949e;}
  .comp-check::before{content:'→';color:#00d4ff;font-family:'JetBrains Mono',monospace;font-size:11px;flex-shrink:0;}
  .comp-widget{background:#060c14;border:1px solid rgba(0,212,255,0.1);border-radius:10px;padding:18px;display:flex;flex-direction:column;gap:8px;}
  .comp-w-hdr{display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;}
  .comp-w-title{font-size:13px;font-weight:600;color:#e6edf3;}
  .comp-w-badge{font-size:9px;font-family:'JetBrains Mono',monospace;color:#4a5568;background:#0a0f1a;padding:2px 8px;border-radius:2px;letter-spacing:0.5px;}
  .comp-gauge{border-radius:6px;padding:11px 13px;}
  .comp-gauge-g{background:rgba(63,185,80,0.06);border:1px solid rgba(63,185,80,0.2);}
  .comp-gauge-y{background:rgba(254,188,46,0.06);border:1px solid rgba(254,188,46,0.2);}
  .comp-gauge-b{background:rgba(0,212,255,0.04);border:1px solid rgba(0,212,255,0.12);}
  .comp-gauge-n{background:#080d14;border:1px solid #1a2a3a;}
  .comp-gauge-row{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;}
  .comp-gauge-label{font-size:12px;font-weight:500;color:#e6edf3;}
  .comp-gauge-val{font-family:'JetBrains Mono',monospace;font-size:13px;font-weight:600;}
  .comp-bar-track{height:4px;background:#1a2a3a;border-radius:2px;overflow:hidden;}
  .comp-bar-fill{height:100%;border-radius:2px;transition:width 0.4s ease;}
  .comp-gauge-sub{font-size:10px;color:#4a5568;margin-top:4px;font-family:'JetBrains Mono',monospace;}
  .comp-status{display:flex;justify-content:space-between;align-items:center;padding:7px 12px;background:rgba(63,185,80,0.06);border:1px solid rgba(63,185,80,0.18);border-radius:5px;}
  .comp-firms{font-size:11px;color:#4a5568;font-family:'JetBrains Mono',monospace;margin-top:6px;}
`;

const detectors = [
  { name: "Overtrading correlation", suite: "Risk", cost: "-$1,277/mo", color: "#febc2e" },
  { name: "Impulsiveness cost", suite: "Psychology", cost: "-$549/mo", color: "#4F8EF7" },
  { name: "Position size drift", suite: "Risk", cost: "-$510/mo", color: "#febc2e" },
  { name: "Revenge trading", suite: "Psychology", cost: "-$420/mo", color: "#4F8EF7" },
  { name: "Rule violations", suite: "Behavior", cost: "-$487/mo", color: "#b87333" },
  { name: "Off-hours trading", suite: "Context", cost: "-$290/mo", color: "#3fb950" },
  { name: "Fear & greed patterns", suite: "Psychology", cost: "-$320/mo", color: "#4F8EF7" },
  { name: "Stop loss adherence", suite: "Risk Discipline", cost: "-$28/mo", color: "#f85149" },
];

const features = [
  { icon: "🧠", tag: "22 Detectors", title: "Behavioral analytics", desc: "Four suites — Behavior, Risk, Psychology, Context — each surfacing an estimated monthly cost per pattern detected in your trades." },
  { icon: "🏦", tag: "Multi-firm", title: "Prop firm dashboard", desc: "Every funded account in one place. Drawdown, challenge progress, payout history, expenses, and ROI across all your firms — TopStep, Apex, Bulenox, and more." },
  { icon: "✅", tag: "Live · Session", title: "Today's Plan", desc: "Real-time rule status every session. Blackout windows, daily drawdown, loss limits, max trades, and news blackouts checked live. One green checkmark means you're safe to trade." },
  { icon: "✈️", tag: "Pre-session", title: "Pre-flight check", desc: "Readiness scored before every session across physical, mental, and discipline dimensions — with your active behavioral patterns checked so you know what to watch for before you place a trade." },
  { icon: "🤖", tag: "AI-powered", title: "AI coaching insights", desc: "Synthesizes all 22 detector outputs into a coaching narrative with one top-priority rule to work on this week. Updated every session." },
  { icon: "🧪", tag: "What-if", title: "Eval survival simulator", desc: "Test your actual trade history against any prop firm's ruleset — TopStep, Apex, Bulenox, and more. See exactly which firms you would have passed and what held you back." },
  { icon: "📊", tag: "Per-trade", title: "Execution scorecard", desc: "Rule adherence, conviction, focus, and impulsiveness scored on every trade vs your personal baseline. Pattern context attached automatically." },
  { icon: "📅", tag: "Month-over-month", title: "Monthly review", desc: "Behavioral snapshots compared month-to-month. See which patterns improved, worsened, or emerged — with estimated cost deltas attached." },
  { icon: "📈", tag: "Edge finding", title: "By Setup analytics", desc: "Win rate, R-multiple, avg confidence, and impulsiveness broken down per setup. AI identifies your highest-edge setups and flags the ones quietly draining your account." },
  { icon: "🌍", tag: "Event-aware", title: "Market Intelligence", desc: "Economic calendar tied to your own trading history. See your win rate and avg P&L on FOMC days, CPI days, NFP days — and whether you should be trading them at all." },
  { icon: "😤", tag: "Emotion-driven", title: "Psychology analytics", desc: "Tag fear, focus, impulsiveness, and mental state at trade time. Futures OS correlates your emotional states with actual outcomes — revealing what your feelings are costing you." },
  { icon: "🗂️", tag: "Portfolio", title: "Multi-account manager", desc: "Add every funded account across every firm. Each account gets its own rules, drawdown tracking, and behavioral analysis. One login, full picture." },
  { icon: "📉", tag: "New · Per-account", title: "Compliance dashboard", desc: "Drawdown buffer gauge, daily loss limit, profit target progress, and consistency rule tracker — live on your dashboard every session. Auto-fills Topstep, Apex, MFF, Tradeify defaults.", isNew: true },
  { icon: "🗄️", tag: "New · History preserved", title: "Blown account archive", desc: "When an account resets, the trade history stays. Review exactly what happened, see the behavioral patterns that led there, and make sure it doesn't happen again.", isNew: true },
  { icon: "🕐", tag: "New · Calendar-aware", title: "Today's trading windows", desc: "Six time blocks across your trading day — Pre-Open through Late Session — each marked Clean, Caution, or Avoid based on today's high-impact USD events. A ±30 min buffer around every event flags the risky windows automatically. Appears on your Can I Trade result so you know not just if you're ready — but when today is safe to trade.", isNew: true },
  { icon: "💰", tag: "Multi-firm · ROI", title: "Prop firm ROI reporting", desc: "Track payouts, eval fees, and expenses across every prop firm you trade — TopStep, Apex, Bulenox, Tradeify, and more. See your true net ROI per firm and across all accounts combined. Know which firms are actually making you money.", isNew: false },
  { icon: "🎯", tag: "New · Behavioral score", title: "Trader sentiment", desc: "A live 0–100 score across win rate, rule adherence, drawdown room, and avg R:R. Locked In → In Rhythm → Steady → Drifting → Off Track. Updates every session.", isNew: true },
];

export function LandingPage({ onSignIn, onSignUp, authError: externalAuthError }) {
  const [showLogin, setShowLogin]     = useState(false);
  const [email, setEmail]             = useState("");
  const [password, setPassword]       = useState("");
  const [isSignUp, setIsSignUp]       = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeTerms, setAgreeTerms]   = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms]     = useState(false);
  const [loading, setLoading]         = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError]             = useState(null);

  const closeLegalModal = () => { setShowPrivacy(false); setShowTerms(false); };

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      let result;
      if (isSignUp) {
        result = await onSignUp(email, password, null, {
          agreedToPrivacy: agreePrivacy,
          agreedToTerms:   agreeTerms,
          privacyVersion:  PRIVACY_VERSION,
          termsVersion:    TERMS_VERSION,
        });
      } else {
        result = await onSignIn(email, password);
      }
      if (result?.error) setError(result.error.message || result.error || "Authentication failed");
    } catch (err) {
      setError(err.message || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  const openSignUp = () => { setIsSignUp(true); setEmail(""); setPassword(""); setShowLogin(true); };
  const openDemo   = () => { setIsSignUp(false); setEmail("demo@futures-os.com"); setPassword("FuturesDemo2026!"); setShowLogin(true); };

  if (showPrivacy) return (
    <div style={{ minHeight:"100vh", background:"#080d14", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ width:"100%", maxWidth:600, maxHeight:"90vh", overflow:"auto", background:"#0d1520", borderRadius:12, padding:24, border:"1px solid #1a2a3a" }}>
        <LegalDocument title="Privacy Policy" />
        <button onClick={closeLegalModal} style={{ width:"100%", padding:12, marginTop:16, background:"#00d4ff", color:"#080d14", border:"none", borderRadius:6, cursor:"pointer", fontWeight:700, fontSize:14 }}>← Back to Sign Up</button>
      </div>
    </div>
  );

  if (showTerms) return (
    <div style={{ minHeight:"100vh", background:"#080d14", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ width:"100%", maxWidth:600, maxHeight:"90vh", overflow:"auto", background:"#0d1520", borderRadius:12, padding:24, border:"1px solid #1a2a3a" }}>
        <LegalDocument title="Terms of Service" />
        <button onClick={closeLegalModal} style={{ width:"100%", padding:12, marginTop:16, background:"#00d4ff", color:"#080d14", border:"none", borderRadius:6, cursor:"pointer", fontWeight:700, fontSize:14 }}>← Back to Sign Up</button>
      </div>
    </div>
  );

  return (
    <div className="landing">
      <style>{css}</style>

      <nav className="nav">
        <div className="nav-logo"><div className="nav-dot" />FUTURES.OS</div>
        <div className="nav-links">
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <a href="#demo">Demo</a>
          <a href="/trade-card">Trade card</a>
        </div>
        <button onClick={() => { setIsSignUp(false); setShowLogin(true); }} className="btn-g" style={{marginRight:8}}>Sign in</button>
        <button onClick={openSignUp} className="nav-cta">Start free trial</button>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="eyebrow">For Serious Prop Traders</div>
        <h1>Awareness. Discipline. Accountability.<br /><em>The operating system for prop traders who take their craft seriously.</em></h1>
        <p className="hero-sub">Futures OS helps you see your patterns, reinforces your rules, and keeps you accountable to your process — every session, every trade, every decision before you click buy or sell.</p>
        <div className="hero-btns">
          <button className="btn-p" onClick={openSignUp}>Start 30-day free trial →</button>
          <button className="btn-g" onClick={openDemo}>View demo account</button>
        </div>
        <div className="hero-meta">No credit card required<span>·</span>Tradovate · Rithmic · NinjaTrader · Sierra Chart · TopStep<span>·</span>First insight in 5 minutes</div>
      </section>

      {/* STATS */}
      <div className="stats">
        {[
          { n: "22", l: "Behavioral detectors", c: "#00d4ff" },
          { n: "$1,500+", l: "Typical leak found", c: "#b87333" },
          { n: "30", l: "Day free trial", c: "#e6edf3" },
          { n: "12", l: "Platform features", c: "#e6edf3" },
          { n: "5 min", l: "To first insight", c: "#e6edf3" },
        ].map(s => (
          <div className="stat" key={s.l}>
            <div className="stat-n" style={{ color: s.c }}>{s.n}</div>
            <div className="stat-l">{s.l}</div>
          </div>
        ))}
      </div>

      {/* FOUNDER'S NOTE */}
      <div className="wrap" style={{paddingBottom:0}}>
        <div style={{
          background:"#0d1520",
          border:"1px solid #1a2a3a",
          borderLeft:"3px solid #00d4ff",
          borderRadius:8,
          padding:"36px 40px",
          maxWidth:760,
        }}>
          <div style={{
            fontFamily:"'JetBrains Mono',monospace",
            fontSize:10, color:"#b87333", letterSpacing:"2px",
            textTransform:"uppercase", marginBottom:18,
          }}>From the founder</div>
          <p style={{fontSize:17, lineHeight:1.7, color:"#e6edf3", marginBottom:16, fontWeight:500}}>
            I'm not a developer who studied traders. I'm a trader who lived this — and I've spent 30+ years in technology.
          </p>
          <p style={{fontSize:15, lineHeight:1.75, color:"#8b949e", marginBottom:16}}>
            I was laid off. Then my savings and retirement were stolen. Then, in
            the worst stretch of my life, I blew through $2.5 million in funded
            accounts — trading in fear, unable to see it while it was happening.
            Fear makes you chase losses, oversize, hold what you should cut. Every
            one of those patterns I'd have caught instantly in another trader. I
            couldn't catch it in myself.
          </p>
          <p style={{fontSize:15, lineHeight:1.75, color:"#8b949e", marginBottom:24}}>
            Futures OS is the tool I needed and didn't have. I built it so the next
            trader sees it coming.
          </p>
          <div style={{
            fontFamily:"'Bricolage Grotesque',sans-serif",
            fontSize:14, fontWeight:600, color:"#e6edf3",
          }}>
            — Michael
            <span style={{
              display:"block", fontFamily:"'JetBrains Mono',monospace",
              fontSize:11, fontWeight:400, color:"#4a5568",
              letterSpacing:"0.5px", marginTop:3,
            }}>Founder, Futures OS</span>
          </div>
        </div>
      </div>

      {/* DASHBOARD */}
      <div className="wrap">
        <div className="sec-label">The platform</div>
        <h2 className="sec-h2">Built for funded futures traders.</h2>
        <p className="sec-sub">Everything in one place — behavioral analytics to prop firm ROI tracking.</p>
        <div className="dash-frame">
          <div className="dash-bar">
            <div className="d dr" /><div className="d dy" /><div className="d dg" />
            <span className="dash-url">futures-os.app/dashboard · Apex $100K Funded · All Time</span>
          </div>
          <div className="dash-grid">
            <div className="dk"><div className="dk-l">Total P&L</div><div className="dk-v" style={{color:"#3fb950"}}>+$5,599</div><div className="dk-s" style={{color:"#3fb950"}}>↑ all time</div></div>
            <div className="dk"><div className="dk-l">Win Rate</div><div className="dk-v" style={{color:"#e6edf3"}}>58.7%</div><div className="dk-s">92 trades</div></div>
            <div className="dk"><div className="dk-l">Est. Monthly Leak</div><div className="dk-v" style={{color:"#f85149"}}>-$1,712</div><div className="dk-s" style={{color:"#f85149"}}>4 patterns active</div></div>
            <div className="dk"><div className="dk-l">Profit Factor</div><div className="dk-v" style={{color:"#e6edf3"}}>2.49</div><div className="dk-s">strong edge</div></div>
            <div className="dk dw">
              <div className="dk-l">Equity Curve</div>
              <svg width="100%" height="52" viewBox="0 0 400 52" preserveAspectRatio="none">
                <polyline points="0,48 50,44 100,40 150,42 200,30 240,22 280,26 320,15 360,10 400,6" fill="none" stroke="#3fb950" strokeWidth="1.5"/>
                <polyline points="0,48 50,44 100,40 150,42 200,30 240,22 280,26 320,15 360,10 400,6 400,52 0,52" fill="rgba(63,185,80,0.07)" stroke="none"/>
              </svg>
            </div>
            <div className="dk"><div className="dk-l">Drawdown Remaining</div><div className="dk-v" style={{color:"#febc2e",fontSize:16}}>$2,140</div><div className="dk-s" style={{color:"#febc2e"}}>71% of limit used</div></div>
            <div className="da"><div className="da-t">Revenge trading detected</div><div className="da-c">-$420/mo</div><div className="da-s">14 triggers this month — avg loss 38% larger after a losing trade</div></div>
            <div className="da" style={{borderLeftColor:"#febc2e"}}><div className="da-t">Position size drift</div><div className="da-c" style={{color:"#febc2e"}}>-$510/mo</div><div className="da-s">Size 2x+ on 22% of trades — correlated with afternoon sessions</div></div>
          </div>
        </div>
      </div>

      {/* COMPLIANCE CALLOUT */}
      <div style={{position:"relative",zIndex:1,padding:"0 0 80px"}}>
        <div className="comp-section">
          <div className="comp-grid">
            <div>
              <div className="sec-label">Prop firm compliance</div>
              <h2 className="sec-h2" style={{marginBottom:14}}>You were up $2,400.<br/>You pulled back to $800.<br/>Your floor moved. <em style={{fontStyle:"normal",color:"#00d4ff"}}>You had no idea.</em></h2>
              <p style={{fontSize:14,color:"#8b949e",lineHeight:1.7,marginBottom:24,fontWeight:300,maxWidth:460}}>EOD trailing drawdown means every new high permanently tightens the gap between your balance and account termination. Futures OS tracks the floor so you always know exactly how much room you have — before the session ends it for you.</p>
              <div className="comp-checklist">
                <div className="comp-check">Drawdown buffer gauge — green / yellow / red on your dashboard</div>
                <div className="comp-check">Daily loss limit tracking per session</div>
                <div className="comp-check">Profit target progress for eval and funded accounts</div>
                <div className="comp-check">Consistency rule tracker — flags payout blockers before they hit</div>
                <div className="comp-check">Auto-fills firm defaults in one click</div>
              </div>
              <div className="comp-firms">Covers Topstep · Apex · MyFundedFutures · Tradeify · Earn2Trade · Bulenox</div>
            </div>
            <div className="comp-widget">
              <div className="comp-w-hdr">
                <span className="comp-w-title">📊 Prop firm compliance</span>
                <span className="comp-w-badge">EOD TRAIL</span>
              </div>
              <div className="comp-gauge comp-gauge-g">
                <div className="comp-gauge-row">
                  <span className="comp-gauge-label">Drawdown buffer</span>
                  <span className="comp-gauge-val" style={{color:"#3fb950"}}>$1,840</span>
                </div>
                <div className="comp-bar-track"><div className="comp-bar-fill" style={{width:"73%",background:"#3fb950"}}></div></div>
                <div className="comp-gauge-sub">EOD trailing · floor $48,160</div>
              </div>
              <div className="comp-gauge comp-gauge-y">
                <div className="comp-gauge-row">
                  <span className="comp-gauge-label">Daily loss limit</span>
                  <span className="comp-gauge-val" style={{color:"#febc2e"}}>54%</span>
                </div>
                <div className="comp-bar-track"><div className="comp-bar-fill" style={{width:"54%",background:"#febc2e"}}></div></div>
                <div className="comp-gauge-sub">$540 used of $1,000 today</div>
              </div>
              <div className="comp-gauge comp-gauge-b">
                <div className="comp-gauge-row">
                  <span className="comp-gauge-label">Profit target</span>
                  <span className="comp-gauge-val" style={{color:"#00d4ff"}}>61%</span>
                </div>
                <div className="comp-bar-track"><div className="comp-bar-fill" style={{width:"61%",background:"#00d4ff"}}></div></div>
                <div className="comp-gauge-sub">$1,830 of $3,000</div>
              </div>
              <div className="comp-gauge comp-gauge-n">
                <div className="comp-gauge-row">
                  <span className="comp-gauge-label">Consistency rule</span>
                  <span className="comp-gauge-val" style={{color:"#3fb950"}}>38% <span style={{fontSize:10,color:"#4a5568"}}>/ 50% max</span></span>
                </div>
                <div className="comp-gauge-sub">Best day $690 · total profit $1,830 · no violation</div>
              </div>
              <div className="comp-status">
                <span style={{fontSize:11,color:"#8b949e"}}>Topstep · PROP · Balance $51,840</span>
                <span style={{fontSize:11,fontWeight:700,color:"#3fb950"}}>● Compliant</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FEATURES */}
      <div className="wrap" style={{paddingTop:0}} id="features">
        <div className="sec-label">What's inside</div>
        <h2 className="sec-h2">Not a journal. An operating system.</h2>
        <p className="sec-sub">Every feature built for the problems funded futures traders actually face.</p>
        <div className="feat-grid">
          {features.map(f => (
            <div className="fc" key={f.title} style={f.isNew ? {borderTop: "2px solid #00d4ff"} : {}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
                <div className="fc-icon" style={{marginBottom:0}}>{f.icon}</div>
                {f.isNew && <span style={{fontSize:9,fontFamily:"'JetBrains Mono',monospace",fontWeight:700,letterSpacing:"1px",color:"#080d14",background:"#00d4ff",padding:"2px 8px",borderRadius:2,textTransform:"uppercase",flexShrink:0}}>New</span>}
              </div>
              <div className="fc-tag">{f.tag.replace("New · ","")}</div>
              <div className="fc-title">{f.title}</div>
              <p className="fc-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* TRADING IDENTITY */}
      <div className="wrap" style={{paddingTop:0}}>
        <div className="sec-label">Trading identity</div>
        <h2 className="sec-h2">Your data reveals <em style={{fontStyle:"normal",color:"#00d4ff"}}>who you are</em> as a trader.</h2>
        <p className="sec-sub">Most traders guess their style. Futures OS derives your trader type from actual trade history — and scores how well you're executing it with an Edge Score out of 100.</p>
        <div className="tid-layout">
          <div className="tid-card">
            <div className="tid-meta">Your Trading Identity · 74 trades</div>
            <div className="tid-type">
              <span className="tid-icon">⚡</span>
              <span className="tid-name">High-Frequency Scalper</span>
            </div>
            <p className="tid-desc">Volume-based edge across 74 trades. Quick execution and tight risk control are your weapons — 67.6% win rate validates the approach.</p>
            <div className="tid-edge">Your clearest edge: Support Bounce (88% WR) · 10am–12pm (68% WR)</div>
            <div className="tid-badge">✓ No costly behavioral patterns detected</div>
          </div>
          <div className="tid-score">
            <div className="tid-score-label">Edge Score</div>
            <div className="tid-score-num">76</div>
            <div className="tid-score-tier">Developing Edge</div>
            {[
              {label:"Win Rate",pts:17,max:30,color:"#febc2e"},
              {label:"Profit Factor",pts:20,max:25,color:"#3fb950"},
              {label:"Sample Size",pts:15,max:20,color:"#3fb950"},
              {label:"Clean Patterns",pts:25,max:25,color:"#3fb950"},
            ].map(b => (
              <div className="tid-bar-row" key={b.label}>
                <div className="tid-bar-top">
                  <span className="tid-bar-name">{b.label}</span>
                  <span className="tid-bar-score" style={{color:b.color}}>{b.pts}/{b.max}</span>
                </div>
                <div className="tid-bar-track">
                  <div className="tid-bar-fill" style={{width:`${(b.pts/b.max)*100}%`,background:b.color}}/>
                </div>
              </div>
            ))}
            <div className="tid-tip">
              <span style={{color:"#febc2e",flexShrink:0}}>💡</span>
              <span>Win rate (68%) is your biggest drag. Focus on setup quality over trade frequency.</span>
            </div>
          </div>
          <div className="tid-types">
            {[
              {icon:"🏆",name:"Elite Disciplined",tag:"75%+ WR · 3x+ PF",active:false},
              {icon:"🎯",name:"Precision Trend",tag:"65%+ WR · directional",active:false},
              {icon:"⚡",name:"High-Freq Scalper",tag:"50+ trades · volume",active:true},
              {icon:"🚀",name:"Momentum Trader",tag:"55%+ WR · 2x+ PF",active:false},
              {icon:"📈",name:"Developing Edge",tag:"45%+ WR · building",active:false},
              {icon:"🌱",name:"Building Story",tag:"Early stage · <20 trades",active:false},
            ].map(t => (
              <div className={`tid-pill${t.active?" tid-active":""}`} key={t.name}>
                <div className="tid-pill-icon">{t.icon}</div>
                <div className={`tid-pill-name${t.active?" tid-active":""}`}>{t.name}</div>
                <div className="tid-pill-tag">{t.tag}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* VS JOURNAL */}
      <div className="wrap" style={{paddingTop:0}}>
        <div style={{padding:"24px 28px",background:"#0d1520",border:"1px solid #1a2a3a",borderRadius:8,display:"grid",gridTemplateColumns:"1fr 1px 1fr",gap:"0 28px",alignItems:"start"}}>
          <div>
            <div style={{fontFamily:"'JetBrains Mono',monospace",fontSize:"9px",color:"#b87333",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:14}}>Traditional trading journals</div>
            {["Require manual notes after every trade","Show patterns — not what they cost","No prop firm ROI or eval fee tracking","No trader identity or edge scoring","No free trial (TradeZella starts at $29/mo)"].map(i=>(
              <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",padding:"7px 0",borderBottom:"1px solid #111922",fontSize:13,color:"#4a5568"}}>
                <span style={{color:"#f85149",fontFamily:"'JetBrains Mono',monospace",flexShrink:0,marginTop:1}}>✗</span>{i}
              </div>
            ))}
          </div>
          <div style={{background:"#1a2a3a",alignSelf:"stretch"}}/>
          <div>
            <div style={{fontFamily:"'JetBrains Mono',monospace",fontSize:"9px",color:"#00d4ff",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:14}}>Futures OS</div>
            {["CSV upload — no journaling required","Every pattern has an estimated monthly dollar cost","Full prop firm ROI, eval fee & payout tracking","Derives your trader type and Edge Score from data","30 days free, then $15/mo — no credit card required"].map(i=>(
              <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",padding:"7px 0",borderBottom:"1px solid #111922",fontSize:13,color:"#8b949e"}}>
                <span style={{color:"#00d4ff",fontFamily:"'JetBrains Mono',monospace",flexShrink:0,marginTop:1}}>→</span>{i}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* DETECTORS */}
      <div className="wrap" style={{paddingTop:0}}>
        <div className="sec-label" style={{marginBottom:20}}>Sample patterns detected</div>
        {detectors.map(d => (
          <div className="det-row" key={d.name}>
            <div style={{display:"flex",alignItems:"center",gap:14}}>
              <div className="det-bar" style={{background:d.color}}/>
              <div>
                <div className="det-name">{d.name}</div>
                <div className="det-suite">{d.suite} suite</div>
              </div>
            </div>
            <div className="det-cost">{d.cost}</div>
          </div>
        ))}
      </div>

      <hr className="divider"/>

      {/* PRICING */}
      <div className="wrap" id="pricing">
        <div className="sec-label">Pricing</div>
        <h2 className="sec-h2">One plan. Everything included.</h2>
        <p className="sec-sub">No feature gates. No per-account fees. Cancel anytime.</p>
        <div className="p-grid" style={{gridTemplateColumns:"1fr",maxWidth:360}}>
          <div className="p-card p-feat">
            <div className="p-name">Futures OS Pro</div>
            <div className="p-price">$15<span>/mo</span></div>
            <div className="p-save">Billed monthly · cancel anytime</div>
            <hr className="p-div"/>
            <ul className="p-feats">
              {["All 22 behavioral detectors","Unlimited trade imports","Full prop firm dashboard","ROI & payout tracking","Eval survival simulator","AI coaching insights","Pre-flight check"].map(f=><li key={f}>{f}</li>)}
            </ul>
            <button className="p-btn pb-p" onClick={openSignUp}>Start free trial</button>
          </div>
        </div>
        <div className="p-note">30-day free trial · No credit card required · Cancel from billing page anytime</div>
      </div>

      <hr className="divider"/>

      {/* DEMO */}
      <div className="wrap" id="demo">
        <div className="demo-grid">
          <div>
            <div className="sec-label">How it works</div>
            <h2 className="sec-h2">Up and running in minutes.</h2>
            <p className="sec-sub">Import your trade history and your behavioral cost shows up automatically.</p>
            {[
              {n:"01",t:"Export your CSV",d:"Pull your Performance CSV from Tradovate, Rithmic, NinjaTrader, Sierra Chart, or TopStep. Takes 30 seconds from your broker dashboard."},
              {n:"02",t:"Drop it in",d:"Drag your file onto the import screen. Trades parse, deduplicate, and load. Scale-in positions aggregate automatically."},
              {n:"03",t:"See your leak",d:"Detectors run immediately. You'll see your estimated monthly behavioral cost in your very first session."},
              {n:"04",t:"Get your priority",d:"AI coaching synthesizes everything into one rule to work on this week. No noise, just the highest-leverage action."},
            ].map(s => (
              <div className="step-item" key={s.n}>
                <div className="step-n">{s.n}</div>
                <div><div className="step-title">{s.t}</div><p className="step-desc">{s.d}</p></div>
              </div>
            ))}
          </div>
          <div>
            <div className="sec-label">Live demo</div>
            <h2 className="sec-h2">See it before you commit.</h2>
            <p className="sec-sub">A pre-loaded demo account with 90 days of real trading patterns already detected. No sign-up required.</p>
            <div style={{background:"#0d1520",border:"1px solid #1a2a3a",borderRadius:8,padding:22,marginBottom:20}}>
              {[
                {l:"Est. monthly leak",v:"-$1,712",c:"#f85149"},
                {l:"Win rate",v:"58.7%",c:"#e6edf3"},
                {l:"Profit factor",v:"2.49",c:"#3fb950"},
                {l:"Active patterns",v:"4",c:"#febc2e"},
                {l:"Total trades",v:"92",c:"#e6edf3"},
              ].map(k => (
                <div key={k.l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #1a2a3a"}}>
                  <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"#4a5568",letterSpacing:"0.5px"}}>{k.l}</span>
                  <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:14,fontWeight:500,color:k.c}}>{k.v}</span>
                </div>
              ))}
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button className="btn-p" onClick={openDemo} style={{width:"100%",padding:13}}>View live demo account →</button>
              <button className="btn-g" onClick={openSignUp} style={{width:"100%",padding:13}}>Start free trial</button>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="wrap" style={{paddingTop:0}}>
        <div className="cta-block">
          <h2 className="cta-h2">Find your leak in 30 days.</h2>
          <p className="cta-sub">Free trial. No credit card. Import your first CSV in under 5 minutes.</p>
          <div className="cta-btns">
            <button className="btn-p" onClick={openSignUp} style={{fontSize:15,padding:"14px 40px"}}>Start free trial →</button>
            <button className="btn-g" onClick={openDemo} style={{fontSize:15,padding:"14px 40px"}}>View demo</button>
          </div>
          <div className="cta-note">$15/mo · cancel anytime</div>
        </div>
      </div>

      <div style={{textAlign:"center",padding:"0 48px 28px",fontSize:11,color:"#4a5568",fontFamily:"'JetBrains Mono',monospace",lineHeight:1.7}}>
        Behavioral cost estimates are based on historical trade patterns and are for informational purposes only. Futures OS is not a financial advisor. Not affiliated with any prop firm.
      </div>

      <footer className="footer">
        <div className="footer-logo">FUTURES.OS</div>
        <div className="footer-links">
          <a href="/legal?tab=privacy">Privacy Policy</a>
          <a href="/legal?tab=terms">Terms of Service</a>
          <a href="mailto:admin@futures-os.app">admin@futures-os.app</a>
        </div>
        <div className="footer-copy">© 2026 Futures OS</div>
      </footer>

      {/* AUTH MODAL */}
      {showLogin && (
        <div
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              const startX = e.clientX, startY = e.clientY;
              const up = (ue) => { if (Math.abs(ue.clientX-startX)<5 && Math.abs(ue.clientY-startY)<5) setShowLogin(false); document.removeEventListener("mouseup",up); };
              document.addEventListener("mouseup", up);
            }
          }}
          style={{ position:"fixed", inset:0, background:"#000000cc", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:20 }}
        >
          <div style={{ background:"#0d1520", border:"1px solid #1a2a3a", borderRadius:16, padding:"40px 36px", width:"100%", maxWidth:400 }}>
            <div style={{ fontSize:20, fontWeight:700, color:"#e6edf3", marginBottom:8, fontFamily:"'Bricolage Grotesque',sans-serif" }}>
              {isSignUp ? "Start your free trial" : "Sign in to Futures OS"}
            </div>
            <div style={{ fontSize:13, color:"#8b949e", marginBottom:28 }}>
              {isSignUp ? "30 days free, then $15/month" : "Welcome back"}
            </div>
            <form onSubmit={handleAuth}>
              <div style={{ marginBottom:16 }}>
                <label style={{ fontSize:12, color:"#8b949e", display:"block", marginBottom:6 }}>Email</label>
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required
                  autoComplete={isSignUp ? "off" : "email"}
                  style={{ width:"100%", padding:"12px 14px", background:"#080d14", border:"1px solid #1a2a3a", borderRadius:6, color:"#e6edf3", fontSize:14, boxSizing:"border-box" }} />
              </div>
              <div style={{ marginBottom:24 }}>
                <label style={{ fontSize:12, color:"#8b949e", display:"block", marginBottom:6 }}>Password</label>
                <div style={{ position:"relative" }}>
                  <input type={showPassword?"text":"password"} value={password} onChange={e=>setPassword(e.target.value)} required
                    autoComplete={isSignUp ? "new-password" : "current-password"}
                    style={{ width:"100%", padding:"12px 40px 12px 14px", background:"#080d14", border:"1px solid #1a2a3a", borderRadius:6, color:"#e6edf3", fontSize:14, boxSizing:"border-box" }} />
                  <button type="button" onClick={()=>setShowPassword(p=>!p)}
                    style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:"#8b949e", cursor:"pointer", fontSize:16, padding:0 }}>
                    {showPassword ? "🙈" : "👁"}
                  </button>
                </div>
              </div>
              {(error || externalAuthError) && (
                <div style={{ marginBottom:16, padding:"10px 12px", background:"#ff000015", border:"1px solid #ff000040", borderRadius:6, fontSize:13, color:"#ff6b6b" }}>
                  {error || externalAuthError}
                </div>
              )}
              {isSignUp && (
                <div style={{ marginBottom:16, display:"flex", flexDirection:"column", gap:10 }}>
                  <label style={{ display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#8b949e", lineHeight:1.5 }}>
                    <input type="checkbox" checked={agreePrivacy} onChange={e=>setAgreePrivacy(e.target.checked)} style={{ marginTop:3, cursor:"pointer", accentColor:"#00d4ff", flexShrink:0 }} />
                    <span>I have read and agree to the <button type="button" onClick={()=>setShowPrivacy(true)} style={{ background:"none", border:"none", color:"#00d4ff", textDecoration:"underline", cursor:"pointer", fontSize:12, padding:0 }}>Privacy Policy</button>.</span>
                  </label>
                  <label style={{ display:"flex", alignItems:"flex-start", gap:8, cursor:"pointer", fontSize:12, color:"#8b949e", lineHeight:1.5 }}>
                    <input type="checkbox" checked={agreeTerms} onChange={e=>setAgreeTerms(e.target.checked)} style={{ marginTop:3, cursor:"pointer", accentColor:"#00d4ff", flexShrink:0 }} />
                    <span>I have read and agree to the <button type="button" onClick={()=>setShowTerms(true)} style={{ background:"none", border:"none", color:"#00d4ff", textDecoration:"underline", cursor:"pointer", fontSize:12, padding:0 }}>Terms of Service</button>.</span>
                  </label>
                </div>
              )}
              <button type="submit" disabled={loading||(isSignUp&&(!agreePrivacy||!agreeTerms))}
                style={{ width:"100%", padding:14, background:(loading||(isSignUp&&(!agreePrivacy||!agreeTerms)))?"#1a2a3a":"#00d4ff", border:"none", borderRadius:6, color:(loading||(isSignUp&&(!agreePrivacy||!agreeTerms)))?"#8b949e":"#080d14", fontSize:15, fontWeight:700, cursor:(loading||(isSignUp&&(!agreePrivacy||!agreeTerms)))?"default":"pointer", marginBottom:16 }}>
                {loading ? "Please wait…" : isSignUp ? "Create Account" : "Sign In →"}
              </button>
            </form>
            <div style={{ textAlign:"center", fontSize:13, color:"#8b949e" }}>
              {isSignUp ? "Already have an account? " : "Don't have an account? "}
              <button onClick={()=>{ setIsSignUp(s=>{ if(!s){ setEmail(""); setPassword(""); } return !s; }); }} style={{ background:"none", border:"none", color:"#00d4ff", cursor:"pointer", fontWeight:600, fontSize:13 }}>
                {isSignUp ? "Sign in" : "Start free trial"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
